const textFieldModalPlaces = {
  name: 'Nombre',
  childLabel: 'Tipo de Rama',
  helperText: 'Por ejemplo: sitio, departamento, sala, galpón, ...',
  latitude: 'Latitud',
  longitude: 'Longitud'
};

export default textFieldModalPlaces;
